//@ts-nocheck
import * as type from "lib/actions/actionTypes";
import { requestInitiate } from "lib/actions/common";

export const setCartProductQuantity = (itemID, quantity) =>
  requestInitiate(type.CART_SET_PRODUCT_QUANTITY, { itemID, quantity });
export const removeProductFromCart = (itemID) => requestInitiate(type.CART_REMOVE_PRODUCT, itemID);
